(() => {
  const desktopMedia = window.matchMedia('(min-width: 990px)');
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  /* =========================================================
     ADET SEÇİCİYİ SATIN ALMA DÜĞMELERİNİN YANINA TAŞIR
     ========================================================= */

  function positionPurchaseControls(container) {
    const quantitySelector = container.querySelector(
      '[id^="Quantity-Form-"]'
    );

    const purchaseButtons = container.querySelector(
      '.product-form__buttons'
    );

    if (!quantitySelector || !purchaseButtons) return;

    if (!quantitySelector.alaOriginalPosition) {
      const placeholder = document.createComment(
        'Âlâ Design quantity position'
      );

      quantitySelector.parentNode.insertBefore(
        placeholder,
        quantitySelector
      );

      quantitySelector.alaOriginalPosition = placeholder;
    }

    if (desktopMedia.matches) {
      if (quantitySelector.parentNode !== purchaseButtons) {
        purchaseButtons.prepend(quantitySelector);
      }
    } else {
      const placeholder = quantitySelector.alaOriginalPosition;

      if (placeholder?.parentNode) {
        placeholder.parentNode.insertBefore(
          quantitySelector,
          placeholder.nextSibling
        );
      }
    }
  }

  /* =========================================================
     ÜRÜN AKORDEONU
     ========================================================= */

  function getAccordionContent(details) {
    return details.querySelector('.accordion__content');
  }

  function clearAccordionStyles(content) {
    content.style.removeProperty('height');
    content.style.removeProperty('opacity');
    content.style.removeProperty('overflow');
  }

  function stopCurrentAnimation(details) {
    if (details.alaAccordionAnimation) {
      details.alaAccordionAnimation.cancel();
      details.alaAccordionAnimation = null;
    }
  }

  function openAccordion(details, animate = true) {
    const content = getAccordionContent(details);

    if (!content) {
      details.open = true;
      return;
    }

    stopCurrentAnimation(details);
    details.open = true;

    if (!animate || reducedMotion.matches) {
      clearAccordionStyles(content);
      return;
    }

    content.style.overflow = 'hidden';

    const targetHeight = content.scrollHeight;

    details.alaAccordionAnimation = content.animate(
      [
        {
          height: '0px',
          opacity: 0
        },
        {
          height: `${targetHeight}px`,
          opacity: 1
        }
      ],
      {
        duration: 900,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
      }
    );

    details.alaAccordionAnimation.onfinish = () => {
      clearAccordionStyles(content);
      details.alaAccordionAnimation = null;
    };
  }

  function closeAccordion(details, animate = true) {
    if (!details.open) return;

    const content = getAccordionContent(details);

    if (!content) {
      details.open = false;
      return;
    }

    stopCurrentAnimation(details);

    if (!animate || reducedMotion.matches) {
      details.open = false;
      clearAccordionStyles(content);
      return;
    }

    const currentHeight = content.getBoundingClientRect().height;

    content.style.overflow = 'hidden';

    details.alaAccordionAnimation = content.animate(
      [
        {
          height: `${currentHeight}px`,
          opacity: 1
        },
        {
          height: '0px',
          opacity: 0
        }
      ],
      {
        duration: 750,
        easing: 'cubic-bezier(0.55, 0, 1, 0.45)'
      }
    );

    details.alaAccordionAnimation.onfinish = () => {
      details.open = false;
      clearAccordionStyles(content);
      details.alaAccordionAnimation = null;
    };
  }

  function initializeProductAccordion(container) {
    const accordionItems = Array.from(
      container.querySelectorAll('.product__accordion details')
    );

    if (!accordionItems.length) return;

    const groupAlreadyInitialized = accordionItems.some(
      (details) => details.dataset.alaAccordionInitialized === 'true'
    );

    if (!groupAlreadyInitialized) {
      accordionItems.forEach((details, index) => {
        details.open = index === 0;
      });
    }

    accordionItems.forEach((details) => {
      if (details.dataset.alaAccordionInitialized === 'true') {
        return;
      }

      const summary = details.querySelector('summary');

      if (!summary) return;

      details.dataset.alaAccordionInitialized = 'true';

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (details.open) {
          closeAccordion(details);
          return;
        }

        accordionItems.forEach((otherDetails) => {
          if (otherDetails !== details && otherDetails.open) {
            closeAccordion(otherDetails);
          }
        });

        openAccordion(details);
      });
    });
  }

    /* =========================================================
     ÜRÜN PAYLAŞIMI
     ========================================================= */

  async function copyProductLink(url) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
      return;
    }

    const textArea = document.createElement('textarea');

    textArea.value = url;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';

    document.body.appendChild(textArea);
    textArea.select();

    const copied = document.execCommand('copy');

    textArea.remove();

    if (!copied) {
      throw new Error('Bağlantı kopyalanamadı.');
    }
  }

  function showShareFeedback(button, message) {
    const feedback = button.querySelector(
      '.ala-product-share-feedback'
    );

    if (!feedback) return;

    clearTimeout(button.alaShareFeedbackTimer);

    feedback.textContent = message;
    button.classList.add('is-copied');

    button.alaShareFeedbackTimer = setTimeout(() => {
      button.classList.remove('is-copied');
      feedback.textContent = 'Paylaş';
    }, 2200);
  }

  function getProductShareUrl(container, button) {
    const shareUrl = new URL(
      button.dataset.shareUrl || window.location.href,
      window.location.origin
    );

    const selectedVariantInput = container.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (selectedVariantInput?.value) {
      shareUrl.searchParams.set(
        'variant',
        selectedVariantInput.value
      );
    }

    return shareUrl.toString();
  }

  function initializeProductShare(container) {
    const shareButton = container.querySelector(
      '.ala-product-share-button'
    );

    if (
      !shareButton ||
      shareButton.dataset.alaShareInitialized === 'true'
    ) {
      return;
    }

    shareButton.dataset.alaShareInitialized = 'true';

    shareButton.addEventListener('click', async () => {
      const title =
        shareButton.dataset.shareTitle || document.title;

      const url = getProductShareUrl(
        container,
        shareButton
      );

      if (navigator.share) {
        try {
          await navigator.share({
            title,
            url
          });

          return;
        } catch (error) {
          if (error.name === 'AbortError') {
            return;
          }
        }
      }

      try {
        await copyProductLink(url);

        showShareFeedback(
          shareButton,
          'Bağlantı kopyalandı'
        );
      } catch (error) {
        showShareFeedback(
          shareButton,
          'Kopyalanamadı'
        );
      }
    });
  }

  /* =========================================================
     ADEDE GÖRE TOPLAM FİYAT
     ========================================================= */

  function calculateTotalPriceText(unitPriceText, quantity) {
    const amountMatch = unitPriceText.match(/\d[\d.]*,\d{2}/);

    if (!amountMatch) return unitPriceText;

    const unitAmount = Number(
      amountMatch[0].replace(/\./g, '').replace(',', '.')
    );

    if (!Number.isFinite(unitAmount)) return unitPriceText;

    const totalAmount = (unitAmount * quantity).toLocaleString(
      'tr-TR',
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    );

    return unitPriceText.replace(amountMatch[0], totalAmount);
  }

  function initializeQuantityPrice(container) {
    if (
      container.dataset.alaQuantityPriceInitialized === 'true'
    ) {
      return;
    }

    const priceContainer = container.querySelector(
      '[id^="price-"]'
    );

    if (!priceContainer) return;

    container.dataset.alaQuantityPriceInitialized = 'true';

    let renderFrame;

    const renderTotalPrice = () => {
      const quantityInput = container.querySelector(
        'input.quantity__input[name="quantity"]'
      );

      const quantity = Math.max(
        1,
        Number.parseInt(quantityInput?.value, 10) || 1
      );

      priceContainer
        .querySelectorAll('.price-item')
        .forEach((priceItem) => {
          if (!priceItem.dataset.alaUnitPriceText) {
            priceItem.dataset.alaUnitPriceText =
              priceItem.textContent.trim();
          }

          const totalPriceText = calculateTotalPriceText(
            priceItem.dataset.alaUnitPriceText,
            quantity
          );

          if (priceItem.textContent.trim() !== totalPriceText) {
            priceItem.textContent = totalPriceText;
          }
        });
    };

    const scheduleTotalPriceRender = () => {
      cancelAnimationFrame(renderFrame);

      renderFrame = requestAnimationFrame(renderTotalPrice);
    };

    const handleQuantityChange = (event) => {
      if (
        event.target.matches(
          'input.quantity__input[name="quantity"]'
        )
      ) {
        scheduleTotalPriceRender();
      }
    };

    container.addEventListener('input', handleQuantityChange);
    container.addEventListener('change', handleQuantityChange);

    const priceObserver = new MutationObserver(
      scheduleTotalPriceRender
    );

    priceObserver.observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });

    scheduleTotalPriceRender();
  }

  /* =========================================================
     BAŞLATMA
     ========================================================= */

  function initializeProductInfo(root = document) {
    root
      .querySelectorAll('.product__info-container')
      .forEach((container) => {
        positionPurchaseControls(container);
        initializeQuantityPrice(container);
        initializeProductAccordion(container);
        initializeProductShare(container);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeProductInfo(),
      { once: true }
    );
  } else {
    initializeProductInfo();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeProductInfo(event.target);
  });

  const handleScreenChange = () => initializeProductInfo();

  if (desktopMedia.addEventListener) {
    desktopMedia.addEventListener('change', handleScreenChange);
  } else {
    desktopMedia.addListener(handleScreenChange);
  }
})();
